import { atom } from "jotai";
import OfflineDeviceRecord from "models/view-models/offline/offline-device-record";

export const CurrentOfflineDeviceAtom = atom<OfflineDeviceRecord | undefined>(
    undefined
);
